{
    "Profile_Menu.ViewRenewalPolicy": "View Renewal Policy",
    "Profile_Menu.IssueQuote": "Issue Quote",
    "Profile_Menu.Issue": "Issue Policy",
    "Profile_Menu.SendPaymentLink": "Send Payment Link",
    "Profile_Menu.ChargeCard": "Charge Card",
    "Profile_Menu.Endorse": "Endorse",
    "Profile_Menu.FinalizeQuote": "Finalize Quote",
    "Profile_Menu.Modal.IssueQuote": "Issue Quote",
    "Profile_Menu.Modal.IssuePolicy": "Issue Policy",
    "Profile_Menu.Modal.SendProposalEmail": "Send Proposal Email",
    "Profile_Menu.Modal.SendPolicyConfirmation": "Send Policy Confirmation",
    "Profile_Menu.Modal.SelectDocuments": "Select documents to attach:",
    "Profile_Menu.Modal.Download": "Download",
    "Profile_Menu.Modal.AddCC": "Add a CC:",
    "Profile_Menu.Modal.AddNote": "Add a note:",
    "Profile_Menu.Modal.EmailInfo": "The insured will receive an email containing any attachment you have included, along with any notes you have added to the notes area above.",
    "Profile_Menu.Modal.Cancel": "Cancel",
    "Profile_Menu.Modal.Issue": "Issue",
    "Profile_Menu.Modal.Confirm": "Confirm",
    "Profile_Menu.Modal.Create": "Create",
    "Profile_Menu.Modal.Submit": "Submit",
    "Profile_Menu.Modal.ConfirmBind": "Confirm Bind",
    "Profile_Menu.Modal.EnterPolicyNumber": "Enter Policy Number",
    "Profile_Menu.Modal.PaymentLinkTitle": "Send Payment Link",
    "Profile_Menu.Modal.PaymentLinkInfo1": "Your customer will receive an email with a link to pay for their policy.",
    "Profile_Menu.Modal.PaymentLinkInfo2": "If successful, the policy will automatically bound and documents will be generated and made available to the insured in Customer portal branded by your brokerage.",
    "Profile_Menu.Modal.PaymentLinkConfirm": "This can't be undone. Are you sure?",
    "Profile_Menu.Modal.PaymentLinkFollowUp": "Follow up with your customer if you have not been notified or the policy status is set to unpaid.",
    "Profile_Menu.Modal.PaymentLinkConfirmationTitle": "Payment Link Sent",
    "Profile_Menu.Modal.SuccessTitle": "Success!",
    "Profile_Menu.Modal.ErrorTitle": "Error!",
    "Profile_Menu.Modal.PaymentLinkSuccessMessage": "A payment link has been sent to your customer to complete.",
    "Profile_Menu.Modal.PaymentLinkSuccessInfo": "You will be notified by email once the payment is complete and the policy will be automatically bound.",
    "Profile_Menu.Modal.PaymentLinkLabel": "Payment Link:",
    "Profile_Menu.Modal.PaymentLinkErrorMessage": "We are unable to send a payment link. Please check for validation errors.",
    "Profile_Menu.Modal.PaymentLinkWindowClosedInfo1": "This payment link cannot be sent because the payment would be received outside the allowed payment window.",
    "Profile_Menu.Modal.PaymentLinkWindowClosedInfo2": "Please review the policy details. You can extend the payment window from the payment page if payment is still required.",
    "Profile_Menu.Modal.Ok": "Ok",
    "Profile_Menu.Modal.LoseLeadTitle": "Lose",
    "Profile_Menu.Modal.LoseLeadReason": "Reason",
    "Profile_Menu.Modal.LoseLeadQuestion": "Why didn't we win?",
    "Profile_Menu.Modal.RejectPolicyTitle": "Reject Policy",
    "Profile_Menu.Modal.RejectPolicyReason": "Reason",
    "Profile_Menu.Modal.RejectPolicyQuestion": "Why didn't we want this lead?",
    "Profile_Menu.Modal.RejectReferralTitle": "Decline",
    "Profile_Menu.Modal.RejectReferralReason": "Decline Reason",
    "Profile_Menu.Modal.RejectReferralQuestion": "Why are you declining this referral?",
    "Profile_Menu.Modal.AcceptReferralTitle": "Accept Referral",
    "Profile_Menu.Modal.AcceptReferralOverridableErrors": "Errors will be overrided",
    "Profile_Menu.Modal.EndorsementTitle": "Create an Endorsement",
    "Profile_Menu.Modal.EndorsementInfo": "You are about to create an Endorsement for this policy",
    "Profile_Menu.Modal.EffectiveDate": "Effective Date",
    "Profile_Menu.Modal.EndorsementCreatedSuccess": "Endorsement created successfully",
    "Profile_Menu.Modal.EndorsementCreatedError": "Failed to create endorsement",
    "Profile_Menu.Modal.EndorsementLostError": "Failed to set endorsement to lost",
    "Profile_Menu.Modal.CancelPolicyTitle": "Cancel Policy",
    "Profile_Menu.Modal.CancellationDate": "Cancellation Date",
    "Profile_Menu.Modal.CancellationReason": "Cancellation Reason",
    "Profile_Menu.Modal.CancellationReasonQuestion": "Why is this policy being cancelled?",
    "Profile_Menu.Modal.CancellationOtherReason": "Please specify",
    "Profile_Menu.Modal.CancellationOtherReasonPlaceholder": "Enter cancellation reason",
    "Profile_Menu.Modal.ChangeCancellationDateTitle": "Change Cancellation Date",
    "Profile_Menu.Modal.Update": "Update",
    "Profile_Menu.Modal.CancellationCreatedSuccess": "Cancellation created",
    "Profile_Menu.Modal.CancellationCreatedError": "Failed to create cancellation",
    "Profile_Menu.Modal.CancellationQuoteError": "Failed to quote cancellation",
    "Profile_Menu.Modal.CancellationDeleteError": "Failed to delete cancellation",
    "Profile_Menu.Modal.CancellationDateUpdateError": "Failed to update cancellation date",
    "Profile_Menu.Modal.RefundTitle": "Process Refund",
    "Profile_Menu.Modal.RefundAmount": "Refund Amount: {amount}",
    "Profile_Menu.Modal.RefundOverrideAmount": "Override Refund Amount",
    "Profile_Menu.Modal.RefundOverridePlaceholder": "Enter amount",
    "Profile_Menu.Modal.Apply": "Apply",
    "Profile_Menu.Modal.RefundMethod": "Refund Method",
    "Profile_Menu.Modal.RefundReference": "Reference",
    "Profile_Menu.Modal.RefundReferencePlaceholder": "e.g. transfer reference or check number",
    "Profile_Menu.Modal.RefundDate": "Refund Date",
    "Profile_Menu.Modal.CompleteRefund": "Complete Refund",
    "Profile_Menu.Modal.RefundOverrideError": "Failed to override refund amount",
    "Profile_Menu.Modal.RefundCompleteError": "Failed to complete refund",
    "Profile_Menu.Input.EmailPlaceholder": "Enter email addresses separated by comma or semicolon",
    "Profile_Menu.Input.NotePlaceholder": "Enter your note here",
    "Profile_ActionsMenu.ContinueQuote": "Continue Quote",
    "Profile_ActionsMenu.Abandon": "Abandon",
    "Profile_ActionsMenu.Submit": "Submit",
    "Profile_ActionsMenu.SendPaymentLink": "Send Payment Link",
    "Profile_ActionsMenu.ChargeCard": "Charge Card",
    "Profile_ActionsMenu.Recover": "Recover",
    "Profile_ActionsMenu.AcceptSubmission": "Accept Submission",
    "Profile_ActionsMenu.RejectSubmission": "Reject Submission",
    "Profile_ActionsMenu.Lost": "Lose",
    "Profile_ActionsMenu.GetQuote": "Get Quote",
    "Profile_ActionsMenu.AcceptReferral": "Accept Referral",
    "Profile_ActionsMenu.RejectReferral": "Decline",
    "Profile_ActionsMenu.ReQuote": "Re-Quote",
    "Profile_ActionsMenu.IssueQuote": "Issue Quote",
    "Profile_ActionsMenu.RequestBind": "Request Bind",
    "Profile_ActionsMenu.ConfirmBind": "Confirm Bind",
    "Profile_ActionsMenu.Bind": "Bind",
    "Profile_ActionsMenu.Issue": "Issue Policy",
    "Profile_ActionsMenu.Endorse": "Endorse",
    "Profile_ActionsMenu.Renew": "Renew",
    "Profile_ActionsMenu.ViewRenewalPolicy": "View Renewal Policy",
    "Profile_ActionsMenu.UnderwriterReviewLink": "Request UW Review",
    "Profile_ActionsMenu.Cancel": "Cancel Policy",
    "Profile_ActionsMenu.CancellationQuote": "Quote",
    "Profile_ActionsMenu.Refund": "Refund",
    "Profile_ActionsMenu.ChangeCancellationDate": "Change Cancellation Date",
    "Profile_ActionsMenu.DeleteCancellation": "Delete",
    "Profile_Menu.Modal.RefundLoadError": "Unable to load the refund details. Please close and try again.",
    "Profile_Menu.Modal.RefundCompleteSuccess": "Refund completed successfully.",
    "Profile_Menu.Modal.RefundMethodPlaceholder": "Select a refund method",
    "Profile_Menu.Modal.CancellationQuoteSuccess": "Cancellation quoted successfully.",
    "Profile_Menu.Modal.CancellationDeleteSuccess": "Cancellation deleted successfully.",
    "Profile_Menu.Modal.CancellationDateUpdateSuccess": "Cancellation date updated successfully.",
    "Profile_Menu.Modal.DeleteCancellationTitle": "Delete Cancellation",
    "Profile_Menu.Modal.DeleteCancellationConfirmation": "This will delete the cancellation. This action cannot be undone.",
    "Profile_Menu.Modal.Delete": "Delete"
}
